import { render } from "./OneColumnPageLayout.vue?vue&type=template&id=2cabef92"
import script from "./OneColumnPageLayout.vue?vue&type=script&lang=js"
export * from "./OneColumnPageLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__